module.exports = __webpack_public_path__ + "img/talk_3.faeb082d.png";